// src/components/SignIn.js
import React, { useState } from 'react';
import '../styles/SignIn.css';

const SignIn = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const handleChange = e => setCredentials({ ...credentials, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    console.log('Sign In Data:', credentials);
  };

  return (
    <div className="form-container">
      <h2>Welcome Back</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Email:
          <input type="email" name="email" value={credentials.email} onChange={handleChange} required />
        </label>
        <label>
          Password:
          <input type="password" name="password" value={credentials.password} onChange={handleChange} required />
        </label>
        <button type="submit" className="btn">Sign In</button>
      </form>
    </div>
  );
};

export default SignIn;
